import { ColumnId } from "../../../components/OrderPageWidgets/OrderTable/components/ModelTable/columns";
import makeTable from "../makeTable";

import { initialSortMethod, initialWidths } from "./data";

const forbiddenColumns = [ColumnId.TimeToDelivery];

const allIds = Object.values(ColumnId).filter(
	(id) => !forbiddenColumns.includes(id),
);

const hiddenColumns = [ColumnId.TransportationType, ColumnId.TimeToDelivery];

const defaultIds = allIds.filter((id) => !hiddenColumns.includes(id));

const orderArchive = makeTable({
	allIds,
	defaultIds,
	i18tPath: (id) => `tableColumns.orders.${id}`,

	initialSortMethod,
	initialWidths,
});

export default orderArchive;
